import {TextField, TextFieldProps} from "@mui/material";
import {Control, Controller, FieldValues, Path, PathValue, useFormContext} from "react-hook-form";
import {useTranslation} from "react-i18next";

type FormTimeFieldProps<IFormValues extends FieldValues = FieldValues> = Omit<TextFieldProps, 'name' | 'value' | 'defaultValue'> & {
    name: Path<IFormValues>,
    control?: Control<IFormValues, any>,
    defaultValue?: PathValue<IFormValues, Path<IFormValues>>
}

const timeRegex = /^[0-9]+:[0-5][0-9]$/;
const isTime = (value: string) => timeRegex.test(value);

const FormTimeField = <IFormValues extends FieldValues = FieldValues>({
    name,
    control,
    defaultValue,
    ...props
}: FormTimeFieldProps<any>) => {
    const {t} = useTranslation(['network', 'translation']);
    const formContext = useFormContext<IFormValues>();

    return (
        <Controller
            name={name}
            control={control ?? formContext.control}
            defaultValue={defaultValue}
            rules={{
                validate: { isTime }
            }}
            render={({ field, fieldState, formState }) =>
                <TextField
                    {...props}
                    ref={field.ref}
                    value={field.value}
                    onChange={(e) => {
                        props.onChange?.(e);
                        field.onChange(e.target.value);
                    }}
                    onBlur={(e) => {
                        props.onBlur?.(e);
                        field.onBlur();
                    }}
                    error={Boolean(props.error || fieldState.error)}
                    helperText={t(!!fieldState.error?.message ? fieldState.error.message : '') ?? props.helperText}
                    disabled={props.disabled ?? formState.isSubmitting}
                    fullWidth
                />
            }
        />
    )
};

export default FormTimeField;